
export const PRESTADOR_CEMENTERIO_TYPE = {

    ARRENDATARIOS: 380,
    PRESTADOR_SERVICIOS: 381

}